var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("accordion-content",null,{"visibleAccordionIndex":_vm.visibleAccordionIndex,"mutationCallback":_vm.onChildListMutation,"removeHash":_vm.removeHash})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }